import api from "../../services/api";
import type {
  GetActivityLogsParams,
  GetActivityLogsResponse,
  GetTournamentActivityLogsParams,
} from "./types";

export const activityLogsApi = {
  /**
   * Get general activity logs (superadmin only)
   */
  getActivityLogs: async (params?: GetActivityLogsParams): Promise<GetActivityLogsResponse> => {
    const queryParams = new URLSearchParams();

    if (params?.page) {
      queryParams.append("page", params.page.toString());
    }
    if (params?.limit) {
      queryParams.append("limit", params.limit.toString());
    }
    if (params?.action) {
      queryParams.append("action", params.action);
    }
    if (params?.resource) {
      queryParams.append("resource", params.resource);
    }
    if (params?.userId) {
      queryParams.append("userId", params.userId);
    }
    if (params?.startDate) {
      queryParams.append("startDate", params.startDate);
    }
    if (params?.endDate) {
      queryParams.append("endDate", params.endDate);
    }

    const queryString = queryParams.toString();
    const url = queryString ? `/activity-logs?${queryString}` : "/activity-logs";
    return api.get(url);
  },

  /**
   * Get tournament-specific activity logs (tournament admin or superadmin)
   */
  getTournamentActivityLogs: async (
    tournamentId: string,
    params?: GetTournamentActivityLogsParams
  ): Promise<GetActivityLogsResponse> => {
    const queryParams = new URLSearchParams();

    if (params?.page) {
      queryParams.append("page", params.page.toString());
    }
    if (params?.limit) {
      queryParams.append("limit", params.limit.toString());
    }
    if (params?.action) {
      queryParams.append("action", params.action);
    }
    if (params?.resource) {
      queryParams.append("resource", params.resource);
    }
    if (params?.startDate) {
      queryParams.append("startDate", params.startDate);
    }
    if (params?.endDate) {
      queryParams.append("endDate", params.endDate);
    }

    const queryString = queryParams.toString();
    const url = queryString
      ? `/activity-logs/tournaments/${tournamentId}?${queryString}`
      : `/activity-logs/tournaments/${tournamentId}`;
    return api.get(url);
  },
};

